import type { Edge } from 'reactflow';
import { SecondaryNodeColor } from 'types';
import { theme } from 'theme';

export const handleNodeColor = (color: SecondaryNodeColor) => {
  switch (color) {
    case SecondaryNodeColor.RED:
      return theme.palette.warning.light;
    case SecondaryNodeColor.BLUE:
      return theme.palette.primary.main;
    case SecondaryNodeColor.GREEN:
      return theme.palette.success.main;
    default:
      return theme.palette.primary.light;
  }
};

export const handleNodeBgColor = (color: SecondaryNodeColor) => {
  switch (color) {
    case SecondaryNodeColor.RED:
      return '#FFFAFA';
    case SecondaryNodeColor.BLUE:
      return '#FAFBFF';
    case SecondaryNodeColor.GREEN:
      return '#FDFFFB';
    default:
      return theme.palette.primary.light;
  }
};

export const handleEdgeColor = (color: SecondaryNodeColor): Edge['style'] => {
  switch (color) {
    case SecondaryNodeColor.RED:
      return {
        strokeWidth: 2,
        stroke: theme.palette.warning.light,
      };
    case SecondaryNodeColor.BLUE:
      return {
        strokeWidth: 2,
        stroke: theme.palette.primary.main,
      };
    case SecondaryNodeColor.GREEN:
      return {
        strokeWidth: 2,
        stroke: theme.palette.success.main,
      };
    default:
      return {
        strokeWidth: 2,
        stroke: theme.palette.primary.light,
      };
  }
};

export const countTooltipLabel = (count: number) => {
  switch (count) {
    case 0:
      return 'Negative';
    case 1:
      return 'Neutral';
    default:
      return 'Positive';
  }
};
